import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import MenuItem from '@material-ui/core/MenuItem'
import { gql, useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import { get } from 'lodash'
import Error from 'components/error'
import TextField from '@material-ui/core/TextField'
import {
  getFieldProps,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const PricesQuery = gql`
  query Prices {
    Prices {
      message
      success
      prices {
        priceId
        price
      }
    }
  }
`

const PricesComp = ({ prices }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { control, errors, setValue } = useFormContext()

  const handlePriceChange = e => {
    setValue('prices', [{ priceId: e.target.value }], {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  return (
    <Controller
      render={({ onChange, value }) => (
        <TextField
          {...fieldProps}
          select
          name="price"
          label="Price"
          error={!!errors.prices}
          helperText={errors?.prices?.message}
          className={fieldClasses.selectInput}
          onChange={e => {
            onChange(e)
            handlePriceChange(e)
          }}
          value={(value && value[0]?.priceId) || ''}
        >
          {prices.map(opt => (
            <MenuItem key={opt.priceId} value={opt.priceId}>
              {opt.price}
            </MenuItem>
          ))}
        </TextField>
      )}
      name="prices"
      control={control}
    />
  )
}

export default function Price() {
  const { data, loading, error } = useQuery(PricesQuery)
  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />

  return <PricesComp prices={get(data, ['Prices', 'prices'], [])} />
}
